const ACTION_TYPES = {
    ON_FIELD_CHANGE: 'ON_FIELD_CHANGE',
    ON_RESET_CLICK: 'ON_RESET_CLICK',
  };

  export default ACTION_TYPES;
